import {
	BCProvider,
	ConfirmationBoxContainer,
	DigitalSignatureContainer,
	IInitializeArgs,
	MessageBoxContainer,
	MessageBoxManager,
	MobileSignatureContainer,
	UserSelectModalContainer
} from '@bimser/common';
import { BCNotificationHolder } from '@bimser/components';
import { createRoot } from 'react-dom/client';
import RouterContainer from './RouterContainer';
import Styles from './assets/style.scss';
// import { initInstrumentation } from "./OpenTelemetryInstrumentation";

const initializeDOM = (args: IInitializeArgs<any>) => {
	const container = document.createElement('main');
	container.className = Styles.container;
	container.setAttribute(
		'style',
		`background-image: var(--theme-image); background-color: var(--theme-color);`
	);

	const body = document.getElementsByTagName('body')[0];
	const themeName = localStorage.getItem('themeName') || 'themeLight';

	localStorage.setItem('themeName', themeName);
	body.className = themeName;

	const toasterContainer = document.createElement('div');
	body.appendChild(toasterContainer);
	body.appendChild(container);

	window.__store = args.store;

	MessageBoxManager();

	// initInstrumentation();

	const root = createRoot(container);
	const toasterRoot = createRoot(toasterContainer);

	root.render(
		<BCProvider
			store={args.store}
			modalComponents={getModalComponents(args)}
			environment="WebInterface"
		>
			<RouterContainer />
		</BCProvider>
	);

	toasterRoot.render(<BCNotificationHolder limit={8} />);
};

function getModalComponents(args: IInitializeArgs<any>) {
	if (!args.modalComponents) {
		args.modalComponents = {};
	}

	args.modalComponents['MESSAGEBOX'] = MessageBoxContainer as any;
	args.modalComponents['ConfirmationBoxModal'] = ConfirmationBoxContainer;
	args.modalComponents['UserSelectModal'] = UserSelectModalContainer;
	args.modalComponents['DigitalSign'] = DigitalSignatureContainer;
	args.modalComponents['MobileSign'] = MobileSignatureContainer;

	window.__modalComponents = args.modalComponents;

	return args.modalComponents;
}

declare global {
	interface Window {
		__store: any;
		__modalComponents: any;
	}
}

export { initializeDOM };
